import client from './contentfulClient';

// Map Contentful entry to article shape
const mapArticle = (entry) => {
  const { fields, sys } = entry;
  return {
    id: fields.slug,
    title: fields.title,
    description: fields.description || '',
    content: fields.content, // Rich text object from Contentful
    image: fields.image?.fields?.file?.url ? `https:${fields.image.fields.file.url}` : null,
    date: fields.created || sys.createdAt,
  };
};

export const getAllArticles = async () => {
  try {
    const response = await client.getEntries({
      content_type: 'article',
    });
    const articles = response.items.map(mapArticle);
    // Sort by date: newest first, oldest last
    return articles.sort((a, b) => new Date(b.date) - new Date(a.date));
  } catch (error) {
    console.error('Error fetching articles from Contentful:', error);
    return [];
  }
};

export const getArticleBySlug = async (slug) => {
  try {
    const response = await client.getEntries({
      content_type: 'article',
      'fields.slug': slug,
      limit: 1,
    });
    if (response.items.length === 0) {
      return null;
    }
    return mapArticle(response.items[0]);
  } catch (error) {
    console.error('Error fetching article from Contentful:', error);
    return null;
  }
};
